import { inject } from '@angular/core';
import type { CanActivateFn} from '@angular/router';
import { Router } from '@angular/router';

import type { Permission } from './permissions';
import { PermissionService } from './permission.service';

/**
 * Factory de guard funcional por permiso.
 *
 * Uso en rutas:
 *   { path: 'documents', canActivate: [authGuard, permissionGuard('documents.read')], ... }
 *
 * Si falta el permiso, redirige a `/forbidden` (la UI no debería ni linkear ahí,
 * pero es defensa por deep-link). El backend igual re-valida en cada request.
 */
export function permissionGuard(...required: Permission[]): CanActivateFn {
  return () => {
    const permissions = inject(PermissionService);
    const router = inject(Router);

    if (permissions.hasAll(required)) {
      return true;
    }
    return router.parseUrl('/forbidden');
  };
}

/** Variante OR: alcanza con uno de los permisos. */
export function permissionGuardAny(...required: Permission[]): CanActivateFn {
  return () => {
    const permissions = inject(PermissionService);
    const router = inject(Router);

    if (permissions.hasAny(required)) {
      return true;
    }
    return router.parseUrl('/forbidden');
  };
}
